export const defaultMediaBreakpoints = {
    sm: 768,
    md: 1024,
    mmd: 1240,
    lg: 1548,
} as const;

export type BreakpointName = keyof typeof defaultMediaBreakpoints;

// Шаг для лучшего понимания диапазона брэйкпоинта
export const BREAKPOINT_STEP = 0.05;

export const createBreakpoints = (breakpoints = defaultMediaBreakpoints) => {
    const unit = 'px';

    const up = (key: BreakpointName) => {
        const value = breakpoints[key];
        return `(min-width:${value}${unit})`;
    };

    const down = (key: BreakpointName) => {
        const value = breakpoints[key];
        return `(max-width:${value - BREAKPOINT_STEP}${unit})`;
    };

    const between = (start: BreakpointName, end: BreakpointName) => {
        return `${up(start)} and ${down(end)}`;
    };

    return {
        up,
        down,
        between,
    };
};

export const breakpoints = createBreakpoints();
